export default "__VITE_ASSET__B9TG8nAM__"